import "prismjs/themes/prism.css";

import "./src/scss/index.scss";
